export default __webpack_public_path__ + "static/team-high-five-5e612e59393f32504310209a32fcd68f.svg";